import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './BooksWithoutLoginAlert.module.scss';

interface Props {
  className?: string;
  onClick: () => void;
}

const BooksWithoutLoginAlert = ({ className, onClick }: Props) => {
  const classes = classNames(css.BooksWithoutLoginAlert, className);
  const intl = useIntl();

  return (
    <div className={classes}>
      <p className={css.BooksWithoutLoginAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.withoutLoginAlertMessage1"
          values={{
            noLogin: (
              <a
                onClick={onClick}
                className={css.BooksWithoutLoginAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({ id: 'books.forms.toUserForm' })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default BooksWithoutLoginAlert;
